// ####################################################################################################################
// REFERENCE ACTIONS
export const FETCH_REFERENCES_REQUEST = "FETCH_REFERENCES_REQUEST";
export const FETCH_REFERENCES_SUCCESS = "FETCH_REFERENCES_SUCCESS";
export const FETCH_REFERENCES_FAILURE = "FETCH_REFERENCES_FAILURE";
export const FETCH_EMPTY_RELATIVE_REFERENCES = "FETCH_EMPTY_RELATIVE_REFERENCES";
export const ADD_REFERENCES_DATA = "ADD_REFERENCES_DATA";
